import {
  useGetUserChoiceBoards,
  useDeleteChoiceBoard,
  getGetUserChoiceBoardsQueryKey,
  useGetTopChoiceBoards,
  likeChoiceBoard,
  unlikeChoiceBoard,
  getGetTopChoiceBoardsQueryKey,
} from "@packages/api/madlenAPI";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { ActivityItem } from "@packages/api/madlenAPI.schemas";
import ChoiceBoardCard from "@features/tools/components/choice-boards/ChoiceBoards";

interface ExtendedTool {
  id: number;
  imageUrl?: string;
  prompt?: string;
  authorName?: string;
  likeCount?: number;
  courseName?: string;
  gradeLevel?: number;
  didUserLiked?: boolean;
  description?: string;
  createdAt?: string;
  isEditable?: boolean;
  title?: string;
  activities?: ActivityItem[];
  choiceBoardInstructions?: string;
  preferredLearningStyles?: string[];
  difficultyDistribution?: string;
  selectionRequirements?: string;
  learningOutcomesFocus?: string[];
}

const ChoiceBoardDetailComponent = ({ tool }: { tool: ExtendedTool }) => {
  return <ChoiceBoardCard choiceBoard={tool} isEditable={tool.isEditable} />;
};

const ChoiceBoardView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserChoiceBoards}
      useDeleteTool={useDeleteChoiceBoard}
      getGetToolsQueryKey={getGetUserChoiceBoardsQueryKey}
      useGetTopTools={useGetTopChoiceBoards}
      likeTool={likeChoiceBoard}
      unlikeTool={unlikeChoiceBoard}
      getGetTopToolsQueryKey={getGetTopChoiceBoardsQueryKey}
      toolType="choiceBoards"
      toolPath="choice-boards"
      DetailComponent={ChoiceBoardDetailComponent}
      colors={{
        light: "from-green-600 to-cyan-600",
        dark: "dark:from-green-400 dark:to-cyan-400",
        iconBg: "bg-green-100 dark:bg-green-900/50",
        iconColor: "text-green-600 dark:text-green-400",
        hover: "hover:bg-green-50 dark:hover:bg-green-900/20",
      }}
      toolColor="green"
      gradientColor="cyan"
    />
  );
};

export default ChoiceBoardView;
